<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12">
                        <DataTable :url="url" :columns="columnasReporte" :params="displayInputs"
                                   :formatterActions="formatterActions" @apiDT="apiDT = $event" :order="[]" class="diario">
                        </DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable,
            Menu
        },
        data() {
            return {
                url: "Indicadores/DefinicionesMensual",
                displayInputs: {
                },
                columnasReporte: [
                    { name: 'Indicador', data: 'indicador', title: "Indicador", },
                    { name: 'Concepto', data: 'concepto', title: "Concepto" },
                    { name: 'Condiciones', data: 'condiciones', title: "Condiciones" },
                    { name: 'Filtros', data: 'filtros', title: "Filtros" },
                    { name: 'Meta a Cubrir', data: 'meta', title: "Meta a Cubrir" },
                    { name: 'Validación', data: 'validacion', title: "Validación" },
                ],
                formatterActions: [
                ],

            }
        }
}
</script>
<style>
    .diario .dataTables_wrapper .dataTables_filter {
        display: none !important;
    }

    .diario .dataTables_wrapper .dataTables_length {
        display: none !important;
    }

    .diario .dataTables_wrapper .dataTables_info {
        display: none !important;
    }

    .diario .dataTables_wrapper .dataTables_paginate {
        display: none !important;
    }
</style>
